const wowApp = require('angular').module('wowApp.common');

wowApp.directive('wowMobileSetStoreNotification', ['StorePickerPanelService', 'GlobalHeaderPanelService', 'StorePickerService', 'AtmService', 'BreakpointsService', '$state', '$timeout', require('./mobile-set-store-notification-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/mobile-set-store-notification/index.js
 **/